
export default {
  name: 'BusinessIcon'
}
